export default __webpack_public_path__ + "media/images/features/ja/main_box_collaboration-96c48b7a6645f12eb4d161b257e3bc63.png";